/*
 *  全局定义信息
 *
 *  @author terrfly
 *  @site https://www.jeepay.vip
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
const passGuardRouteList = [errorPageRouteName, 'Qrcode', 'Redirect', 'Form', 'fast', 'Fast', 'OpenFast', 'OpenIdentity', 'Ebank']  // 不进入路由守卫的name
const passGuardPathPrefixes = ['/up_fast/', '/fast/', '/open_upfast/', '/open_identity/', '/ebank/'] // 路径前缀免守卫（快捷支付、实人认证、网银等）

/** 定义支付方式 **/
const payWay = {
    WXPAY : {wayCode: "WX_JSAPI", routeName: "CashierWxpay"},
    ALIPAY : {wayCode: "ALI_JSAPI", routeName: "CashierAlipay"}
}

export default {
    errorPageRouteName: errorPageRouteName,
    passGuardRouteList: passGuardRouteList,
    passGuardPathPrefixes: passGuardPathPrefixes,
    urlTokenName: "jeepayToken", //URL传递的token名称
    payWay: payWay,
    cacheToken: ""
}